import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { FormControlLabel } from "@mui/material";
import TextField from '@mui/material/TextField';
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { DeleteButton, List, useDataGrid } from "@refinedev/mui";
import SourceStatus from "@warriortrading/warriortrading.hermes.common.feathers/enums/sourceStatus";
import Status from "@warriortrading/warriortrading.hermes.common.feathers/enums/status";
import React, { useState } from "react";
import { SwitchButton } from "../../components/buttons/switch";

export const BadwordsList = () => {
    const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
        sorters: {
            initial: [
              {
                field: "updatedAt",
                order: "desc"
              }
            ]
          },
        pagination: {
            pageSize: 10
          }
    });


    const columns = React.useMemo<GridColumns<any>>(
        () => [
            {
                field: "id",
                headerName: "Id",
                type: "number",
                minWidth: 100,
                hideable: false, 
            },
            {
                field: "text",
                headerName: "Text",
                minWidth: 200,
                flex: 1,
                hideable: false,
            },
            {
                field: "isBad",
                headerName: "IsBad",
                minWidth: 80,
                flex: 1,
                hideable: false,
                renderCell: function render({ row }) {
                    const isBad = row.isBad ? 0 : 1
                    return Object.values(Status)[0].find((item: any) => item.value  === isBad)?.name;
                },
            },
            {
                field: "source",
                headerName: "Source",
                minWidth: 80,
                flex: 1,
                hideable: false,
                renderCell: function render({ row }) {
                    return Object.values(SourceStatus)[0].find((item: any) => item.value  === row.source)?.name;
                },
            },
            {
                field: "createdAt",
                headerName: "Created At",
                minWidth: 200,
                flex: 1,
                hideable: false,
                renderCell: function render({ row }) {
                    if (row.createdAt) {
                        return new Date(row.createdAt).toLocaleString();
                    } else {
                        return "";
                    }
                },
            },
            {
                field: "updatedAt",
                headerName: "Updated At",
                minWidth: 200,
                flex: 1,
                hideable: false,
                renderCell: function render({ row }) {
                    if (row.updatedAt) {
                        return new Date(row.updatedAt).toLocaleString();
                    } else {
                        return "";
                    }
                },
            },
            {
                field: "actions",
                headerName: "Actions",
                hideable: false,
                sortable: false,
                renderCell: function render({ row }) {
                    let checked = row?.isBad;
                    return (
                        <>
                            <SwitchButton hideText recordItemId={row.id} isBad={checked}/>
                            <DeleteButton  hideText recordItemId={row.id} />
                        </>
                    );
                },
                align: "center",
                headerAlign: "center",
                minWidth: 100,
            },
        ],
        [],
    );

    // search parts
    const [text, setText] = useState("");
    const handleFilter = (
        ) => {
            setCurrent(1);
            setPageSize(10);
            let searchArr: {field: string; value: string; operator: string}[] = [];
            if (text) {
                searchArr.push({
                    field: "text[$ilike]",
                    value: `%${text}%`,
                    operator: "eq",
                });
            }
            setFilters(searchArr as any);
        };
    const clearFun = () => {
        setText("");
    }

    return (
        <List>
            <FormControlLabel
                label=""
                style={{width: "100%"}}
                control={
                    <div style={{display:"flex", justifyContent: "space-between", alignItems: "flex-end", width: "100%", marginLeft: "19px", marginBottom: "12px"}}>
                        <div style={{width: "90%", paddingBottom: "3px"}}>
                            <TextField id="standard-basic" label="Text" variant="standard" value={text} onChange={(e) => setText(e.target.value)} fullWidth/>
                        </div>
                        <div style={{width: "60px"}}>
                            <ClearOutlinedIcon onClick={clearFun}/>
                            <SearchIcon onClick={handleFilter}/>
                        </div>
                    </div>
                }
            />
            <DataGrid {...dataGridProps} columns={columns} autoHeight paginationMode="server" rowsPerPageOptions={[10,20,50]} disableColumnFilter/>
        </List>
    );
};
